import { Mark } from "@tiptap/core";

/**
 * Preserves htmlDiff inline spans (<span class="ai-inline ai-added">).
 * Legacy ai-modified spans are treated as ai-added.
 * when we set HTML into the editor. Without this, ProseMirror drops the span tag and the
 * highlights disappear.
 */
export const AIDiffInline = Mark.create({
  name: "aiDiffInline",

  addAttributes() {
    return {
      diff: {
        default: null,
        parseHTML: (element) => {
          const cls =
            element?.getAttribute?.("class") ||
            (typeof element?.className === "string" ? element.className : "");
          const s = String(cls);
          if (
            s.includes("ai-added") ||
            s.includes("ai-modified") ||
            s.includes("ai-removed")
          ) {
            return "added";
          }
          return null;
        },
        renderHTML: (attributes) => {
          const diff = attributes?.diff;
          const klass = diff === "added" ? "ai-added" : "";
          return {
            class: `ai-inline ${klass}`.trim(),
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      { tag: "span.ai-inline.ai-added", priority: 210 },
      { tag: "span.ai-inline.ai-modified", priority: 210 },
      { tag: "span.ai-inline.ai-removed", priority: 210 },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", HTMLAttributes, 0];
  },
});

